import React from 'react';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { lighten, darken } from 'polished';
import { emy, fontUbuntuLight } from '../../utilities/utilities';

const styles = css`
  width: 100%;
  display: inline-flex;
  font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntuLight};
  align-items: center;
  white-space: nowrap;
  font-size: ${emy(21)};
  border: 0.0625em solid ${props => props.border ? props.border : '#003395'};
  /* height: 2.5rem; */
  justify-content: center;
  text-decoration: none;
  cursor: pointer;
  padding: 0.6rem 1rem;
  border-radius: 10rem;
  box-sizing: border-box;
  pointer-events: auto;
  transition: background-color 250ms ease-out, color 250ms ease-out, border-color 250ms ease-out;
  background-color: ${props => props.background ? props.background : '#003395'};
  color: ${props => props.color ? props.color : '#FFFFFF'};
  &:hover, &:focus {
    background-color: ${props => props.background ? darken(0.1, props.background) :  darken(0.1, '#003395')};
    color: ${props => props.color ? props.color : '#FFFFFF'};
  }
  &:active {
    background-color: ${props => props.background ? lighten(0.1, props.background) :  lighten(0.1, '#003395')};
    color: ${props => props.color ? props.color : '#FFFFFF'};
  }
  &:focus {
    outline: none
  }
`;

const StyledLink = styled(Link)`
  ${styles}
`;

const Button = ({...props}) => {
    return <StyledLink {...props} />
}

export default Button


// WEBPACK FOOTER //
// ./src/collections/LinkButton/LinkButton.js